import styled from '@emotion/styled';

import { authColors, authLayout, authTypography } from 'design-system/tokens';

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InfoBand = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 33px ${authLayout.footerPadding};
  background: ${authColors.brand};

  @media (max-width: 1280px) {
    padding: 33px 40px;
  }

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    padding: 32px 24px;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  align-items: center;
  gap: 228px;
  width: 100%;
  max-width: 1000px;

  @media (max-width: ${authLayout.tabletBreakpoint}) {
    gap: 64px;
  }

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
`;

export const BrandColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 17px;
  flex-shrink: 0;
`;

export const BrandLogo = styled.img`
  width: 134px;
  height: 37px;
`;

export const SocialList = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SocialLink = styled.a`
  display: inline-flex;
  line-height: 0;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const ContactColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 464px;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    width: 100%;
  }
`;

export const ContactTitle = styled.h2`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: ${authTypography.titleLarge.size};
  font-weight: ${authTypography.titleLarge.weight};
  line-height: 16px;
  color: ${authColors.white};
`;

export const ContactList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ContactLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: ${authColors.white};
`;

export const ContactValue = styled.a`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  overflow-wrap: anywhere;
  font-weight: 500;
  line-height: 16px;
  text-decoration: underline;
  color: ${authColors.white};

  &:hover {
    color: ${authColors.white};
    opacity: 0.8;
  }
`;

export const LegalBand = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  box-sizing: border-box;
  width: 100%;
  min-height: 80px;
  padding: 16px ${authLayout.footerPadding};
  background: ${authColors.brand};
  border-top: 1px solid ${authColors.white};

  @media (max-width: 1280px) {
    padding: 16px 40px;
  }

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 16px 44px;
    text-align: center;
  }
`;

export const LegalLink = styled.a`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-decoration: underline;
  color: ${authColors.white};

  &:hover {
    color: ${authColors.white};
    opacity: 0.8;
  }
`;

export const Copyright = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    align-items: center;
  }
`;

export const CopyrightTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: ${authColors.white};
`;

export const CopyrightText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${authColors.white};
`;
